import * as z from '@harvestiq/zod';
import { aipIdentifierSchema } from './aip-identifier';

export const aipIdentifiersResponseSchema = z.object({
  data: z.array(aipIdentifierSchema.optional()),
});
export type AipIdentifiersResponse = z.infer<
  typeof aipIdentifiersResponseSchema
>;
